import { render } from "./flight-booking-invoice.vue?vue&type=template&id=0dc9fbfa"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__